import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { ApiService } from "../../api/api.service";
import { ICreateThemeReq, IDeleteTheme_Response, ITheme, IThemeDataRes, IThemeReq, IUpdateThemeReq } from "../../../_models/themes.model";


@Injectable({
  providedIn: "root",
})
export class ThemesService {
  
  constructor(private apiService: ApiService){}

  getAll(req: IThemeReq) {
    let params = new HttpParams({
      fromObject: {
        page: String(req.page),
        limit: String(req.limit),
        ...(req.isActive != null && { isActive: req.isActive }),
        ...(req.search && { search: req.search }),
         ...(req.sort && { sortBy: req.sort }),
        ...(req.sortOrder && { sortOrder: req.sortOrder }),
        ...(req.includeDeleted != null && { includeDeleted: String(req.includeDeleted) }),
      },
    });

    return this.apiService.get<IThemeDataRes>({
      Url: "dating/admin/themes",
      Params: params
    });
  }

  createTheme(reqData: ICreateThemeReq) {
    const form = new FormData();
    form.append("name", reqData.name);
    if (reqData.description) form.append("description", reqData.description);
    if (reqData.entryFee) form.append("entryFee", reqData.entryFee.toString());
    if (reqData.interestsCount) form.append("interestsCount", reqData.interestsCount.toString());
    if (reqData.participantsCount) form.append("participantsCount", reqData.participantsCount.toString());
    if (reqData.isActive != null) form.append("isActive", reqData.isActive.toString());
    if (reqData.startDate) form.append("startDate", new Date(reqData.startDate).toISOString());
    if (reqData.image) form.append("image", reqData.image, reqData.image.name);
    if (reqData.questionGroup) form.append("questionGroup", reqData.questionGroup);
    if (reqData.roundsPerInterest) form.append("roundsPerInterest", reqData.roundsPerInterest.toString());
    if (reqData.genericQuestionsDuration != null) form.append("genericQuestionsDuration", reqData.genericQuestionsDuration.toString());
    if (reqData.genericQuestions) {
      reqData.genericQuestions.forEach(q => form.append("genericQuestions", q));
    }

    return this.apiService.post<ICreateThemeReq, ITheme>({
      Url: 'dating/admin/themes',
      Body: form
    });
  }

  updateTheme(reqData: IUpdateThemeReq) {
    const form = new FormData();
    if (reqData.name) form.append("name", reqData.name);
    if (reqData.isActive != null) form.append("isActive", reqData.isActive.toString());
    if (reqData.startDate) form.append("startDate", new Date(reqData.startDate).toISOString());
    if (reqData.image) form.append("image", reqData.image, reqData.image.name);
    if (reqData.questionGroup) form.append("questionGroup", reqData.questionGroup);
    if (reqData.roundsPerInterest) form.append("roundsPerInterest", reqData.roundsPerInterest.toString());
    if (reqData.genericQuestionsDuration != null) form.append("genericQuestionsDuration", reqData.genericQuestionsDuration.toString());
    if (reqData.genericQuestions) {
      reqData.genericQuestions.forEach(q => form.append("genericQuestions", q));
    }

    return this.apiService.put<IUpdateThemeReq, ITheme>({
      Url: `dating/admin/themes/${reqData.id}`,
      Body: form
    });
  }


  bulkDeleteThemes(ids: string[]) {
    return this.apiService.post<{ids: string[]}, any>({
      Url: `dating/admin/themes/bulk-delete`,
      Body: { ids }
    });
  }
}
